import folderStore from 'owa-folders';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
export default function getBulkActionTooltipText(scenario, folderId) {
    var folderName = folderStore.folderTable.get(folderId).DisplayName;
    switch (scenario) {
        case 'EmptyFolder':
            return format(strings.bulkAction_emptyFolderHover, folderName);
        case 'Sweep':
            return format(strings.bulkAction_sweepHover, folderName);
        case 'RunRuleNow':
            return format(strings.bulkAction_runRuleHover, folderName);
        default:
            throw new Error('Invalid bulk action scenario type');
    }
}
//# sourceMappingURL=getBulkActionTooltipText.js.map